import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError } from 'rxjs';
import { ProductsService } from 'src/app/shared/service/product.service';
import { productDB } from 'src/app/shared/tables/product-list';
import { GuidedTourService } from 'ngx-guided-tour';
import { TourStep } from 'ngx-guided-tour';
import { APIService } from 'src/app/shared/service/apiService.service';
import Swal from 'sweetalert2';
import * as Notiflix from 'notiflix';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ebooks',
  templateUrl: './ebooks.component.html',
  styleUrl: './ebooks.component.scss'
})
export class EbooksComponent {

  public urlLanding: string = '';


  //public product_list = []
  //this.product_list = productDB.product;

  public url: string = '';
  public search: string = '';
  public product_list: any[] = [];
  public filteredProductList: any[] = []; // Lista filtrada de productos
  public filteredCourses: any[] = [];
  public totalProducts: number;
  public showFilter = false;
  public productId: number;
  public deleteIsSuccess = false;
  public selectedStatus: string = ''; // Estado seleccionado
  active: boolean;
  public video: any[] = [];
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };
  profile: any;
  Id: any;
  public isInstructor: boolean = false;
  public currentUser: any; // Usuario actual desde localStorage
  
  // Variables de paginación
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalPages: number = 0;
  public paginatedCourses: any[] = [];
  public Math = Math; // Exponer Math para usar en el template

  // Nuevas variables para filtros avanzados
  public categories: any[] = [];
  public levels: any[] = [];
  public selectedCategories: number[] = [];
  public selectedLevels: number[] = [];
  public orderBy: string = 'created_at';
  public orderDirection: string = 'DESC';
  public showFiltersPanel: boolean = false;
  public showCategoriesCollapse: boolean = true;
  public showLevelsCollapse: boolean = true;
  private searchDebounce: any;
  public loading: boolean = false; // Variable para mostrar spinner

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private productService: ProductsService,
    private guidedTourService: GuidedTourService,
    private apiService: APIService,
  ) { }

  filterCoursesByStatus() {
    // Ya no filtramos en frontend, ahora los filtros van al backend
    this.currentPage = 1; // Resetear a página 1
    this.loadData(); // Hacer nueva consulta con el filtro de status
  }  

  ngOnInit() {
    // Cargar usuario actual desde localStorage (incluye foto y displayName)
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    
    const storedSearch = localStorage.getItem('searchValue');
    if (storedSearch) {
      this.search = storedSearch;
      this.showFilter = true;
    }
    
    // Cargar catálogos de categorías y niveles
    this.loadCategories();
    this.loadLevels();
    
    this.loadData();
    this.loadVideos(); // Cargar el video para el tour
    this.checkUserRole();

    /* const user = JSON.parse(localStorage['currentUser']);

    this.apiService.getById(user.id).subscribe((data: any) => {
      this.profile = data;
      this.Id = this.profile.id;
      console.log('Info', this.Id);
    }); */

    // Inicia el tour después de asegurarse de que el video esté cargado
    setTimeout(() => {
      this.startTour();
    }, 1000);
  }

  private checkUserRole() {
    const user = JSON.parse(localStorage['currentUser']);
    this.isInstructor = user.roles === 'teacher'; // Ajusta esto según la estructura real de tu usuario
  }

  loadCategories() {
    this.productService.getCategoriesCatalog().subscribe({
      next: (data) => {
        this.categories = data.filter((cat: any) => cat.Active === true);
        console.log('📂 Categorías cargadas desde /catalogs-data/category:', this.categories);
        console.log('📂 Ejemplo de categoría con ID:', this.categories[0]);
      },
      error: (err) => {
        console.error('Error al cargar categorías:', err);
        Notiflix.Notify.failure('Error al cargar categorías');
      }
    });
  }

  loadLevels() {
    this.productService.getLevels().subscribe({
      next: (data) => {
        this.levels = data.filter((level: any) => level.Active === true);
        console.log('📊 Niveles cargados desde /catalogs-data/level:', this.levels);
        console.log('📊 Ejemplo de nivel con ID:', this.levels[0]);
      },
      error: (err) => {
        console.error('Error al cargar niveles:', err);
        Notiflix.Notify.failure('Error al cargar niveles');
      }
    });
  }

  updateSearchValue(newValue: string) {
    this.search = newValue;
    if (this.search.trim()) {
      localStorage.setItem('searchValue', this.search);
    }
    
    // Implementar debounce de 500ms
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    
    this.searchDebounce = setTimeout(() => {
      this.currentPage = 1; // Resetear a página 1 al buscar
      this.loadData();
    }, 500);
  }

  clearSearch() {
    this.search = '';
    this.selectedStatus = '';  // Limpiar el estado seleccionado
    this.selectedCategories = [];
    this.selectedLevels = [];
    this.orderBy = 'created_at';
    this.orderDirection = 'DESC';
    localStorage.removeItem('searchValue');
    this.currentPage = 1;
    this.loadData();  // Recargar los datos después de limpiar los filtros
  }

  toggleFiltersPanel() {
    this.showFiltersPanel = !this.showFiltersPanel;
  }

  toggleCategoriesCollapse() {
    this.showCategoriesCollapse = !this.showCategoriesCollapse;
  }

  toggleLevelsCollapse() {
    this.showLevelsCollapse = !this.showLevelsCollapse;
  }

  onCategoryChange(categoryId: number, event: any) {
    if (event.target.checked) {
      if (!this.selectedCategories.includes(categoryId)) {
        this.selectedCategories.push(categoryId);
      }
    } else {
      this.selectedCategories = this.selectedCategories.filter(id => id !== categoryId);
    }
    this.currentPage = 1;
    this.loadData();
  }

  onLevelChange(levelId: number, event: any) {
    if (event.target.checked) {
      if (!this.selectedLevels.includes(levelId)) {
        this.selectedLevels.push(levelId);
      }
    } else {
      this.selectedLevels = this.selectedLevels.filter(id => id !== levelId);
    }
    this.currentPage = 1;
    this.loadData();
  }

  onSortChange(event: any) {
    const value = event.target.value;
    switch(value) {
      case 'title_asc':
        this.orderBy = 'Title';
        this.orderDirection = 'ASC';
        break;
      case 'title_desc':
        this.orderBy = 'Title';
        this.orderDirection = 'DESC';
        break;
      case 'price_asc':
        this.orderBy = 'UnitPrice';
        this.orderDirection = 'ASC';
        break;
      case 'price_desc':
        this.orderBy = 'UnitPrice';
        this.orderDirection = 'DESC';
        break;
      case 'date_desc':
      default:
        this.orderBy = 'created_at';
        this.orderDirection = 'DESC';
        break;
    }
    this.currentPage = 1;
    this.loadData();
  }

  isCategorySelected(categoryId: number): boolean {
    return this.selectedCategories.includes(categoryId);
  }

  isLevelSelected(levelId: number): boolean {
    return this.selectedLevels.includes(levelId);
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  setModalContent(content: any, productId: number, status: boolean): void {
    this.productId = productId;
    this.active = status;
    this.modalService.open(content, this.modalConfig);
  }

  loadData() {
    this.loading = true; // Activar spinner
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const isAdmin = user.roles === 'admin'; // Detectar si es admin
    
    // Construir objeto de filtros - SOLO agregar lo que realmente está seleccionado
    const filters: any = {};
    
    // Agregar filtros solo si están seleccionados
    if (this.selectedStatus) {
      // Enviar directamente en español como espera el backend
      filters.Status = this.selectedStatus;
    }
    
    if (this.selectedCategories.length > 0) {
      // Por ahora tomamos solo la primera categoría
      // TODO: Implementar soporte para múltiples categorías en el backend
      filters.category_id = this.selectedCategories[0];
    }
    
    if (this.selectedLevels.length > 0) {
      // Por ahora tomamos solo el primer nivel
      filters.level_id = this.selectedLevels[0];
    }
    
    // Solo agregar orderBy si es diferente del default
    if (this.orderBy && this.orderBy !== 'created_at') {
      filters.orderBy = this.orderBy;
      filters.orderDirection = this.orderDirection;
    }
    
    console.log('🔍 Filtros enviados al backend:', filters);
    
    this.productService.getEbooks2(this.search, user.id, this.currentPage, this.itemsPerPage, filters).subscribe(data => {
        console.log('📦 Respuesta COMPLETA de la API de ebooks:', data);
        
        // La nueva API devuelve un objeto con estructura de paginación
        if (data && data.data && Array.isArray(data.data)) {
          console.log('✅ Estructura de paginación detectada');
          console.log('📄 Total de ebooks:', data.total);
          console.log('📄 Página actual:', data.page);
          console.log('📄 Total de páginas:', data.totalPages);
          
          this.product_list = data.data;
          this.totalProducts = data.total || data.data.length;
          this.currentPage = data.page || 1;
          this.totalPages = data.totalPages || 1;
        } else if (Array.isArray(data)) {
          // Fallback: Si por alguna razón devuelve un array directo
          console.log('✅ Array directo detectado');
          this.product_list = data;
          this.totalProducts = data.length;
          this.totalPages = Math.ceil(data.length / this.itemsPerPage);
        } else {
          console.error('❌ Estructura de respuesta no reconocida:', data);
          console.error('❌ Tipo de dato:', typeof data);
          console.error('❌ Claves disponibles:', data ? Object.keys(data) : 'N/A');
          this.product_list = [];
          this.totalProducts = 0;
          this.totalPages = 0;
        }
        
        // Ya no filtramos en frontend, el backend ya devuelve los datos filtrados
        this.filteredCourses = this.product_list;
        
        // Los datos ya vienen paginados del backend
        this.paginatedCourses = this.filteredCourses;
        
        console.log(`✅ ${this.totalProducts} ebooks totales - Mostrando ${this.filteredCourses.length} en página ${this.currentPage} de ${this.totalPages}`);
        console.log('📋 Lista de ebooks:', this.filteredCourses);
        
        this.loading = false; // Desactivar spinner
    }, error => {
      console.error('❌ Error al cargar ebooks:', error);
      Notiflix.Notify.failure('Error al cargar los ebooks');
      this.product_list = [];
      this.filteredCourses = [];
      this.totalProducts = 0;
      this.loading = false; // Desactivar spinner en caso de error
    });
  }

  loadVideos(): void {
    const currentUser = localStorage.getItem('currentUser');
  
    if (!currentUser) {
      console.error('El usuario actual no está definido en localStorage.');
      alert('No se pudo obtener la información del usuario.');
      return;
    }
  
    const user = JSON.parse(currentUser);
    const userId = user.id;
  
    if (!userId) {
      console.error('El UserId no está disponible.');
      alert('Hubo un problema al identificar al usuario.');
      return;
    }
  
    const requestBody = {
      descripcion: 'Cursos', // Solo buscamos el video con descripción "Cursos"
      userId: userId
    };
  
    this.productService.getVideos(requestBody).subscribe({
      next: (response) => {
        if (response) {
          const video = response[0]; // Toma el primer elemento del arreglo
          this.video = [video]; // Guarda el video en un arreglo (por consistencia)
        } else {
          console.error('No se encontró un video para "Cursos".');
        }
      },
      error: (err) => {
        console.error('Error al cargar el video:', err);
        alert('Hubo un problema al cargar el video. Inténtalo nuevamente.');
      }
    });
  }
  
  markVideoAsViewed(videoId: number): void {
    this.productService.changeStatusVideo(videoId).subscribe({
      next: () => {
        console.log(`El video con ID ${videoId} ha sido marcado como visto.`);
      },
      error: (err) => {
        console.error(`Error al cambiar el estado del video con ID ${videoId}:`, err);
        alert('Hubo un problema al actualizar el estado del video.');
      }
    });
  }
  
  startTour(): void {
    // Verifica si la lista de videos está vacía
    if (!this.video || this.video.length === 0) {
      console.log('No hay videos disponibles para iniciar el tour.');
      return; // Detiene el inicio del tour
    }

    // Verifica si algún video ya ha sido visto
    const algunVideoVisto = this.video.some(video => 
      video && video.OnboardingVideoUsers && video.OnboardingVideoUsers.length > 0 && video.OnboardingVideoUsers[0]?.Viewed
    );

    if (algunVideoVisto) {
      console.log('El tour no se iniciará porque algunos videos ya han sido vistos.');
      return; // Detiene el inicio del tour
    }

    const tour = {
      tourId: 'CursosTour',
      useOrb: false, // Desactiva el orb
      steps: this.getGeneralSteps(),
      completeCallback: () => {
        console.log('Tour completado');
        if (this.video.length > 0) {
          const video = this.video[0];
          if (video && video.OnboardingVideoUsers && video.OnboardingVideoUsers.length > 0) {
            this.markVideoAsViewed(video.OnboardingVideoUsers[0]?.id as any); // Marca como visto al completar
          }
        }
        this.router.navigate(['/products/courses']); // Redirige al nuevo componente
      },
      skipCallback: () => {
        console.log('Tour omitido');
        if (this.video.length > 0) {
          const video = this.video[0];
          if (video && video.OnboardingVideoUsers && video.OnboardingVideoUsers.length > 0) {
            this.markVideoAsViewed(video.OnboardingVideoUsers[0]?.id as any); // Marca como visto al omitir
          }
        }
        this.router.navigate(['/products/courses']); // Redirige al nuevo componente si se omite el tour
      }
    };
    document.querySelector('ngx-guided-tour')?.classList.add('cursos-tour');
    this.guidedTourService.startTour(tour); // Inicia el tour
  }
  
  getGeneralSteps(): TourStep[] {
    if (this.video && this.video.length > 0) {
      const video = this.video[0]; // Tomar el primer video cargado
      console.log('Videos:', video);
      
      // Validar que el video tenga la propiedad VideoUrl
      if (video && video.VideoUrl) {
        return [
          {
            content: `
              <video controls width="100%" height="100%">
                <source src="${video.VideoUrl}" type="video/mp4">
                Tu navegador no soporta la reproducción de video.
              </video>
            `,
            title: 'Cursos',
            orientation: 'center', // Centrar el paso
            scrollAdjustment: 0 // Ajuste de desplazamiento
          }
        ];
      }
    }
    
    // Si no hay videos o el video no tiene URL, retornar un array vacío
    console.log('No hay videos disponibles para el tour');
    return [];
  }

  openAddCourseModal(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  sendToReview(ebookId: any): void {
    Swal.fire({
        title: '¿Enviar a revisión?',
        text: 'El ebook será enviado para revisión.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            this.productService.sendEbookToReview(ebookId).subscribe({
                next: () => {
                    Swal.fire('Enviado', 'El ebook ha sido enviado a revisión correctamente.', 'success');
                    this.loadData(); // Recargar la lista de ebooks
                },
                error: (err) => {
                    Swal.fire('Error', 'No se pudo enviar el ebook a revisión. Inténtalo nuevamente.', 'error');
                    console.error(err);
                }
            });
        }
    });
  }

  confirmDelete(productId: any): void {
    Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            this.productService.deleteEbooks(productId).subscribe({
                next: () => {
                    Swal.fire('Eliminado', 'El ebook ha sido eliminado correctamente.', 'success');
                    this.loadData(); // Recargar la lista de ebooks
                },
                error: (err) => {
                    Swal.fire('Error', 'No se pudo eliminar el ebook. Inténtalo nuevamente.', 'error');
                    console.error(err);
                }
            });
        }
    });
  }
  
  
  copiarURL(courseSlug: string): void {
    const url = `${environment.WEBURL}landing/${courseSlug}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        Notiflix.Notify.success('¡URL copiada al portapapeles!');
      })
      .catch(() => {
        Notiflix.Notify.failure('Error al copiar la URL');
      });
  }

  // Métodos de paginación
  updatePagination() {
    // Ya no necesitamos calcular paginación en frontend
    // El backend nos da totalPages
    this.paginatedCourses = this.filteredCourses;
  }

  paginateCourses() {
    // Ya no necesitamos paginar en frontend
    this.paginatedCourses = this.filteredCourses;
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadData(); // Recargar datos del backend con la nueva página
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadData(); // Recargar datos del backend
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadData(); // Recargar datos del backend
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
}